module.exports = __webpack_public_path__ + "media/images/safe_and_secure-8694cfdb.svg";